import { AircraftDetails } from '../types/aircraft';
import { Spider, SpiderType } from '../types/spiders';

export const hasSpiderType = (types: SpiderType[]) => (spiders: Spider[]) => (
  aircraft: AircraftDetails
) => spiders.some(s => s.vehicleId === aircraft.id && types.includes(s.spiderType));
